<template>
  <InsiderTradeBig
    v-if="big"
    :key="'insider-' + insider.id + insider.publish_date"
    :insider="insider"
    :publish-date="toDate(insider.publish_date)"
    :company-name="(insider.company) ? insider.company.name : '-'"
    :company-id="(insider.company) ? insider.company.id : null"
    :type-class="getTypeClass(insider)"
    :icon-type-class="getIconTypeClass(insider)"
    :icon="getIcon(insider)"
    :positive="insider.sentiment === 'positive'"
  />
  <InsiderTradeMini
    v-else-if="mini"
    :key="'insider-' + insider.id + insider.publish_date"
    :insider="insider"
    :publish-date="toDate(insider.publish_date)"
    :company-name="(insider.company) ? insider.company.name : '-'"
    :company-id="(insider.company) ? insider.company.id : null"
    :type-class="getTypeClass(insider)"
    :icon-type-class="getIconTypeClass(insider)"
    :icon="getIcon(insider)"
    :positive="insider.sentiment === 'positive'"
  />
  <InsiderTrade
    v-else
    :key="'insider-' + insider.id + insider.publish_date"
    :insider="insider"
    :publish-date="toDate(insider.publish_date)"
    :company-name="(insider.company) ? insider.company.name : '-'"
    :company-id="(insider.company) ? insider.company.id : null"
    :type-class="getTypeClass(insider)"
    :icon-type-class="getIconTypeClass(insider)"
    :company-short-name="(insider.company) ? insider.company.slug_url : null"
    :icon="getIcon(insider)"
    :positive="insider.sentiment === 'positive'"
  />
</template>

<script>

import InsiderTradeBig from './_components/InsiderTradeBig'
import InsiderTradeMini from './_components/InsiderTradeMini'
import InsiderTrade from './_components/InsiderTrade'
import { format } from 'date-fns'

export default {
  name: 'InsiderTradeModule',
  components: {
    InsiderTradeBig,
    InsiderTradeMini,
    InsiderTrade
  },
  props: {
    insider: {
      type: Object,
      default: () => {}
    },
    big: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toDate (datetime) {
      return format(new Date(datetime), 'yyyy-MM-dd kk:mm')
    },
    getTypeClass (insider) {
      if (insider.status === 'Reviderad') {
        return 'text-gray-400 dark:text-custom-purple-300'
      }

      if (insider.sentiment === 'positive') {
        return 'text-custom-purple-400 dark:text-custom-dark-header'
      }

      if (insider.sentiment === 'negative') {
        return 'text-red-400'
      }

      return 'text-gray-600 dark:text-gray-400'
    },
    getIconTypeClass (insider) {
      if (insider.status === 'Reviderad') {
        return 'text-gray-400 dark:text-custom-purple-300'
      }
      if (insider.sentiment === 'positive') {
        return 'text-custom-purple-400 dark:text-custom-green-500'
      }

      if (insider.sentiment === 'negative') {
        return 'text-red-400'
      }

      return 'text-gray-600 dark:text-gray-600'
    },
    getIcon (insider) {
      if (insider.status === 'Reviderad') {
        return 'bookmark-minus'
      }

      if (insider.sentiment === 'positive') {
        return 'line-chart'
      }

      if (insider.sentiment === 'negative') {
        return 'line-chart-down'
      }

      return 'coin-stack'
    }
  }
}
</script>
